import { render, staticRenderFns } from "./TopbarProductionList.vue?vue&type=template&id=135de2b8&scoped=true&"
import script from "./TopbarProductionList.vue?vue&type=script&lang=js&"
export * from "./TopbarProductionList.vue?vue&type=script&lang=js&"
import style0 from "./TopbarProductionList.vue?vue&type=style&index=0&id=135de2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135de2b8",
  null
  
)

export default component.exports